
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29 18c0-5.844-4.581-10.636-10.341-10.978a3.266 3.266 0 00-.36-.022c-.035 0-.07.003-.106.005C18.129 7.003 18.065 7 18 7 11.935 7 7 11.935 7 18s4.935 11 11 11c.064 0 .129-.004.193-.006.035.002.071.006.107.006.12 0 .24-.008.359-.022C24.419 28.636 29 23.844 29 18zm-2.047 3.541c-.378-.11-1.327-.348-3.003-.546a20.954 20.954 0 00.08-5.38c2.123-.254 3.053-.574 3.115-.596l-.255-.722c.476 1.14.74 2.391.74 3.703 0 1.25-.241 2.444-.677 3.541zM13.143 18c0-.77.05-1.52.144-2.243 1.112.087 2.443.152 4.006.167v4.77a58.173 58.173 0 00-3.917.161A17.42 17.42 0 0113.143 18zm5.52-9.534c1.683.49 3.124 2.83 3.769 5.932a53.967 53.967 0 01-3.768.157V8.466zm-1.369.017v6.072a57.144 57.144 0 01-3.775-.156c.659-3.064 2.11-5.387 3.775-5.916zm0 13.582v5.45c-1.553-.493-2.92-2.546-3.632-5.306a57.64 57.64 0 013.632-.144zm1.37 5.469v-5.47a53.45 53.45 0 013.628.15c-.7 2.796-2.059 4.865-3.629 5.32zm0-6.84v-4.77a54.72 54.72 0 003.991-.171 18.249 18.249 0 01-.086 5.106 54.778 54.778 0 00-3.905-.164zm7.973-6.95c-.207.065-1.073.312-2.809.517-.387-2.061-1.087-3.823-1.997-5.096a9.694 9.694 0 014.807 4.58h-.001zM14.716 8.948c-1.12 1.288-2.034 3.14-2.533 5.33-1.554-.168-2.486-.367-2.858-.457a9.681 9.681 0 015.39-4.872v-.001zm-5.9 6.157c.264.071 1.263.32 3.12.526a17.123 17.123 0 00.099 5.35c-1.595.172-2.577.379-3.016.485a9.6 9.6 0 01-.202-6.362h-.002zm.802 7.63a26.566 26.566 0 012.715-.407c.52 1.927 1.367 3.558 2.383 4.726a9.683 9.683 0 01-5.098-4.32zm12.213 4.1c.82-1.145 1.468-2.687 1.871-4.486 1.36.155 2.214.34 2.644.448a9.683 9.683 0 01-4.515 4.037z"}})])
          )
        }
      }
    